export default "__VITE_ASSET__TNqhqyZc__"